import {
  TbCheck,
  TbChevronDown,
  TbChevronLeft,
  TbChevronRight,
  TbChevronUp,
  TbCloudDownload,
  TbCloudUpload,
  TbDeviceMobile,
  TbDeviceMobileMinus,
  TbDeviceMobilePlus,
  TbDotsVertical,
  TbDownload,
  TbFileDownload,
  TbFileUpload,
  TbFilter,
  TbHome,
  TbListCheck,
  TbMenu2,
  TbMinus,
  TbPlus,
  TbRefresh,
  TbShield,
  TbTrash,
  TbUpload,
  TbWallet,
  TbLockOpen,
  TbLogout2,
  TbExternalLink,
  TbArrowsMinimize,
  TbArrowsMaximize,
  TbAlertTriangle,
  TbCircleCheck,
  TbInfoCircle,
  TbCircleX,
  TbFileTypePdf,
  TbFileExport,
} from 'react-icons/tb';
import {
  LuArrowDown,
  LuArrowDownWideNarrow,
  LuArrowLeft,
  LuArrowRight,
  LuArrowUp,
  LuArrowUpDown,
  LuArrowUpNarrowWide,
  LuCreditCard,
  LuLayoutPanelLeft,
  LuListCheck,
  LuMessageSquareWarning,
  LuTriangleAlert,
  LuUserRound,
  LuUsersRound,
  LuX,
  LuUserPlus,
  LuArrowUpLeft,
  LuArrowDownLeft,
  LuArrowDownRight,
  LuArrowUpRight,
  LuMoon,
  LuSun,
} from 'react-icons/lu';
import { FiEdit2, FiList, FiSettings } from 'react-icons/fi';
import { MdCheckBoxOutlineBlank, MdOutlineCheckBox } from 'react-icons/md';

export const IconPlus = TbPlus;

export const IconMinus = TbMinus;

export const IconXmark = LuX;

export const IconXMarkCircle = TbCircleX;

export const IconEdit = FiEdit2;

export const IconFilter = TbFilter;

export const IconCheck = TbCheck;

export const IconCheckCircle = TbCircleCheck;

export const IconInfoCircle = TbInfoCircle;

export const IconExclamationTriangle = TbAlertTriangle;

export const IconSortAsc = LuArrowUpNarrowWide;

export const IconSortDesc = LuArrowDownWideNarrow;

export const IconRefresh = TbRefresh;

export const IconMoreVert = TbDotsVertical;

export const IconSettings = FiSettings;

export const IconUnlock = TbLockOpen;

export const IconExternalLink = TbExternalLink;

export const IconPDF = TbFileTypePdf;

export const IconExport = TbFileExport;

export const IconSun = LuSun;

export const IconMoon = LuMoon;

// LISTS
export const IconList = FiList;

export const IconTaskList = TbListCheck;

export const IconListSelect = LuListCheck;

// ARROWS AND CHEVRONS
export const IconChevronRight = TbChevronRight;

export const IconChevronLeft = TbChevronLeft;

export const IconChevronUp = TbChevronUp;

export const IconChevronDown = TbChevronDown;

export const IconArrowUp = LuArrowUp;

export const IconArrowUpDown = LuArrowUpDown;

export const IconArrowDown = LuArrowDown;

export const IconArrowRight = LuArrowRight;

export const IconArrowLeft = LuArrowLeft;

export const IconArrowUpRight = LuArrowUpRight;

export const IconArrowDownRight = LuArrowDownRight;

export const IconArrowDownLeft = LuArrowDownLeft;

export const IconArrowUpLeft = LuArrowUpLeft;

export const IconArrowsOut = TbArrowsMaximize;

export const IconArrowsIn = TbArrowsMinimize;

export const IconCheckboxEmpty = MdCheckBoxOutlineBlank;

export const IconCheckboxChecked = MdOutlineCheckBox;

//TRASH
export const IconTrash = TbTrash;

// WARNINGS
export const IconWarningMessage = LuMessageSquareWarning;

export const IconWarningTriangle = LuTriangleAlert;

// DOWNLOAD & UPLOADS
export const IconDownload = TbDownload;

export const IconCloudDownload = TbCloudDownload;

export const IconFileDownload = TbFileDownload;

export const IconUpload = TbUpload;

export const IconCloudUpload = TbCloudUpload;

export const IconFileUpload = TbFileUpload;

// USER
export const IconUser = LuUserRound;

export const IconUserGroup = LuUsersRound;

export const IconSmartphoneDevice = TbDeviceMobile;

export const IconSmartphonePlus = TbDeviceMobilePlus;

export const IconSmartphoneMinus = TbDeviceMobileMinus;

export const IconCreditCard = LuCreditCard;

export const IconWallet = TbWallet;

export const IconHome = TbHome;

export const IconDashboard = LuLayoutPanelLeft;

export const IconHamburger = TbMenu2;

export const IconUserPlus = LuUserPlus;

export const IconAdministrators = TbShield;

export const IconLogout = TbLogout2;
